var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgR2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 137,
    viewBox: "0 0 176 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.04 128.747H88.5374L104.821 112.456V71.666L170.833 5.6249L169.507 4.29788L102.945 70.8887V111.679L87.7605 126.876H12.04V128.747Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.527 9.54064e-07L165.201 1.32726L173.818 9.94527L175.144 8.61801L166.527 9.54064e-07Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.733398 127.811C6.05808 129.789 12.6587 133.157 16.7517 136.728L13.5303 127.811L16.7517 118.895C12.6587 122.465 6.05177 125.84 0.733398 127.811Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR2);
export default __webpack_public_path__ + "static/media/r2.b896eadc8911ef9be8b7fd92966c6085.svg";
export { ForwardRef as ReactComponent };